<div class="actions">
    <wms-page-select *ngIf="this.bindVariableService.dialogParams.showPageSelection"></wms-page-select>
    <wms-search id="widget-search-box" name="widget-search-box" width="20em"
        (onSearch)="searchWidgets($event)"></wms-search>
</div>
<div class="widgets-list-container" *ngIf="bindVariableService.allowedCategories.WIDGETS">
    <wms-tree id="widget-search-box" (nodeClick)="bindVariableService.handleTreeNodeClick($event)" sortBy="id" [skipChildNodeSearch]="true" [selectedNode]="bindVariableService.selectedNodeInBindDialog.widget"
        [data]="bindVariableService.filteredWidgetsTree" iconType="plus" [getChildren]="bindVariableService.getChildren"
        [externalSearchKey]="widgetSearchKey"  *ngIf="!bindVariableService.allWidgetsNotFound" >
    </wms-tree>
    <p *ngIf="bindVariableService.allWidgetsNotFound">{{locale.LABEL_WIDGETS_NOT_FOUND}}</p>
</div>
